import { Outlet, useLocation } from 'react-router-dom';

import { Header } from '@/components/common/Header';
import { Footer } from '@/components/common/Footer';
import { useFirebaseAuth } from '@/hooks/useFirebaseAuth';
import { useCloudSync } from '@/hooks/useCloudSync';
import { usePageTracking } from '@/hooks/usePageTracking';

export function RootLayout() {
  const location = useLocation();
  const isEditor = location.pathname.startsWith('/editor');
  const isHome = location.pathname === '/';
  const fullBleed = isEditor || isHome;

  useFirebaseAuth();
  useCloudSync();
  usePageTracking();

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <Header />
      <main className={fullBleed ? 'flex-1' : 'container flex-1 py-8'}>
        <Outlet />
      </main>
      {!isEditor && <Footer />}
    </div>
  );
}
